import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import {
  FindOne,
  ReadReceipt,
  UpdateReadReceipt,
} from '@univacity/shared/types';
import { Observable } from 'rxjs';
import { Configuration } from '../config';

@Injectable({ providedIn: 'root' })
export class MessageMetaService {
  baseUrl: string;

  constructor(private http: HttpClient, private config: Configuration) {
    this.baseUrl = this.config.apiMainUrl + '/message/meta';
  }

  getAllAttachment<T>(thread: string, populate: boolean): Observable<Array<T>> {
    const params = new HttpParams({ fromObject: { populate } });
    return this.http.get<T[]>(`${this.baseUrl}/${thread}/attachments'`, {
      params,
    });
  }
  findOneReadReceipt(
    thread: string,
    query: FindOne = {}
  ): Observable<ReadReceipt> {
    const params = new HttpParams({ fromObject: query as Params });
    return this.http.get<ReadReceipt>(
      `${this.baseUrl}/${thread}/read-receipt`,
      {
        params,
      }
    );
  }

  updateReadReceipt(
    thread: string,
    read: UpdateReadReceipt
  ): Observable<ReadReceipt> {
    return this.http.put<ReadReceipt>(
      `${this.baseUrl}/${thread}/read-receipt`,
      read
    );
  }

  countThreadUnread(thread: string): Observable<number> {
    return this.http.get<number>(
      `${this.baseUrl}/${thread}/read-receipt/count`
    );
  }
  countUserUnread(): Observable<number> {
    return this.http.get<number>(`${this.baseUrl}/read-receipt/count`);
  }
}
